import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { CoursesService } from '../../../service/courses.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AttendanceService } from 'src/app/service/attendance.service';
declare var $: any;

@Component({
  selector: 'app-authorized-absence-request',
  templateUrl: './authorized-absence-request.component.html',
  styleUrls: ['./authorized-absence-request.component.scss']
})
export class AuthorizedAbsenceRequestComponent implements OnInit {
  showLoader: boolean = false;
  absenceRequests: any;
  searched: any = false;
  absTypes:any;
  students:any;
  filterStatus:boolean=true;

  searchForm = new FormGroup({
    filterBy: new FormControl('', [
      // Validators.required,
    ]),
    value: new FormControl('all', [
      Validators.required,
    ])
  });

  constructor(private attendanceService:AttendanceService,private toastrService: ToastrService, public coursesService: CoursesService, public globals: Globals, private router: Router
    , public translate: TranslateService) { }

  ngOnInit(): void {
    this.showLoader = true;
    this.getAbsType();
    // this.absenceRequests = [
    //   {
    //     id: "10",
    //     type: "MA",
    //     student: "441-Student",
    //     dateFrom: "01-SEP-2020",
    //     DateTo: "01-SEP-2020",
    //     remarks: "Text 1234",
    //     attachment: "MedicalReport.pdf",
    //     status: "Accepted",
    //   },
    //   {
    //     id: "20",
    //     type: "UA",
    //     student: "441-Student",
    //     dateFrom: "01-SEP-2020",
    //     DateTo: "02-SEP-2020",
    //     remarks: "Text 45678",
    //     attachment: "File2.pdf",
    //     status: "Rejected",
    //   },
    //   {
    //     id: "30",
    //     type: "MA",
    //     student: "441-Student",
    //     dateFrom: "15-OCT-2021",
    //     DateTo: "15-OCT-2021",
    //     remarks: "Text 789654",
    //     attachment: "File33.pdf",
    //     status: "Under Processing",
    //   },
    //   {
    //     id: "40",
    //     type: "AA",
    //     student: "441-Student",
    //     dateFrom: "25-MAR-2021",
    //     DateTo: "25-MAR-2021",
    //     remarks: "Text 15978",
    //     attachment: "File12456.pdf",
    //     status: "Draft",
    //   },
    // ];
    this.updateTable();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
    });
    this.showLoader = false;
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7]
          }
        }],
      });
    }, 1);
  }

  AssignmentsAbsenceRequest() {
    console.log("Assignments absence request");
  }

  approveAbsenceRequest() {
    console.log("Approve absence request");
  }

  rejectAbsenceRequest() {
    console.log("Reject absence request");
  }

  showStatusHistory() {
    console.log("Show status history");
  }

  searchFormChange() { };
  searchFormSubmit() {
    if (this.searchForm.valid) {
      console.log("Submit search form values");
      console.log(this.searchForm.value);
      this.searched = true;
    }
    else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
    this.updateTable();
  };
  getValues(){
    let filterType=this.searchForm.controls.filterBy.value;
    if(filterType=="student"){
      this.filterStatus=false;
    }else{
      this.filterStatus=true;
    }

  }
  getAbsType() {
    let orgId = this.globals.orgId;
    this.attendanceService.getAbscenceTypes(orgId)
      .subscribe(
        data => {
          this.absTypes = data;
          this.getStudentsByRole();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  getStudentsByRole() {
    let orgId = this.globals.orgId;
    let username = this.globals.currentUserInfo.username;
    let userId =0;
    let studentid=this.globals.currentUserInfo.studentid;
    let teacherid=this.globals.currentUserInfo.teacherid;
    if(studentid!=null){
      userId=studentid;
    }else if(teacherid!=null){
      userId=teacherid;
    }else{
      userId =0;
    }
    this.attendanceService.getStudentsByUser(orgId,username,userId)
      .subscribe(
        data => {
          this.students = data;
          this.getStudentsByUserVW();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  getStudentsByUserVW() {
    let orgId = this.globals.orgId;
    let username = this.globals.currentUserInfo.username;
    let userId =0;
    let studentid=this.globals.currentUserInfo.studentid;
    let teacherid=this.globals.currentUserInfo.teacherid;
    if(studentid!=null){
      userId=studentid;
    }else if(teacherid!=null){
      userId=teacherid;
    }else{
      userId =0;
    }
    this.attendanceService.getStudentsVWByUser(orgId,username,userId)
      .subscribe(
        data => {
          this.absenceRequests = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
}



